var _circle, _circle2, _g, _circle3, _circle4, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVBtcb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    fill: "none",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#1F2028"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "a",
    width: 64,
    height: 64,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 31.5,
    fill: "#1F2028",
    stroke: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M32 72.212.96 8.983l8.08-3.966L32 51.788 54.96 5.017l8.08 3.966L32 72.212Z",
    clipRule: "evenodd",
    opacity: 0.8
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 28,
    fill: "url(#b)",
    opacity: 0.8
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 24,
    fill: "#1F2028"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M42.7 29.06c.473-3.152-1.937-4.846-5.233-5.977l1.07-4.27-2.611-.648-1.04 4.158c-.687-.17-1.392-.331-2.092-.49l1.048-4.185L31.234 17l-1.07 4.269a87.594 87.594 0 0 1-1.667-.39l.003-.014-3.6-.895-.694 2.776s1.937.442 1.896.47c1.057.262 1.248.96 1.216 1.511L24.39 36.425c-.13.32-.457.8-1.196.618.026.037-1.897-.472-1.897-.472L20 39.547l3.397.843c.632.157 1.25.322 1.86.478l-1.08 4.319 2.607.648 1.07-4.273c.712.192 1.404.37 2.08.537l-1.066 4.253 2.61.648 1.08-4.31c4.451.838 7.798.5 9.207-3.51 1.135-3.227-.057-5.089-2.398-6.303 1.705-.392 2.99-1.509 3.332-3.816Zm-5.965 8.328c-.806 3.228-6.263 1.483-8.033 1.046l1.434-5.722c1.769.44 7.443 1.31 6.6 4.676Zm.808-8.374c-.736 2.936-5.278 1.444-6.752 1.079l1.3-5.19c1.473.366 6.218 1.048 5.452 4.11Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 59.284,
    x2: -9.421,
    y1: 48.315,
    y2: 6.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5433FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#20BDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CFFA2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVBtcb);
export default __webpack_public_path__ + "static/media/vBtcb.bdf793b2d42f0b9fff8554ad80c70d18.svg";
export { ForwardRef as ReactComponent };